import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-50 border-t border-secondary-200/50">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-950 mb-3">
              Superbuy Sheet
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your trusted shopping discovery platform. Browse curated product categories
              and discover quality items organized for effortless shopping.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-3">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  Complete Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  Main Website
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-3">
              Popular Categories
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://kaspreadsheet.com/category-911-Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  Shoes
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/search-912/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  Hoodies &amp; Sweaters
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/search-913/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  T-Shirts
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-secondary-200/50">
          <p className="text-xs text-foreground-500 leading-relaxed text-center">
            <strong>Disclaimer:</strong> This website provides educational and informational content only.
            We are an independent resource platform and are not affiliated with Superbuy officially.
            All product links redirect to our main website at kaspreadsheet.com. External links open
            in new tabs with appropriate security measures.
          </p>
          <p className="text-xs text-foreground-400 text-center mt-3">
            &copy; {new Date().getFullYear()} Superbuy Sheet. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}